/**
 * Resolve paths under Vite `public/` for `img src`, `Audio.src`, Phaser loaders, etc.
 *
 * Root-absolute strings like `/ui/foo.webp` request the **host origin** root, which
 * breaks FRVR / subfolder hosting (e.g. `alpha.frvr.com/ui/...` 404). Prefer URLs
 * relative to the deployed `index.html` via {@link import.meta.env.BASE_URL}
 * (`base: "./"` → `./ui/foo.webp`).
 */
export function cwfPublicUrl(path: string): string {
  const p = path.trim();
  if (!p) return p;
  if (/^https?:\/\//i.test(p)) return p;
  if (/^(data:|blob:)/i.test(p)) return p;
  const rel = p.startsWith("/") ? p.slice(1) : p;
  const rawBase = import.meta.env.BASE_URL ?? "/";
  if (rawBase === "./" || rawBase === ".") {
    return `./${rel}`;
  }
  const base = rawBase.endsWith("/") ? rawBase : `${rawBase}/`;
  if (base === "/") {
    return `/${rel}`;
  }
  return `${base}${rel}`;
}

/** Inline `backgroundImage: url('…')` using {@link cwfPublicUrl}. */
export function cwfBackgroundImageUrl(absPublicPath: string): string {
  const u = cwfPublicUrl(absPublicPath).replace(/\\/g, "/").replace(/'/g, "\\'");
  return `url('${u}')`;
}
